"use client";

import React from "react";
import { Activity, Baby, Droplets, HeartPulse, ThermometerSun, Wind } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const conditions = [{
  title: "Bladder Leakage",
  description: "Effective treatments for stress, urge, and mixed incontinence to help you regain confidence and control in your daily life.",
  icon: Droplets
}, {
  title: "Postnatal Recovery",
  description: "Comprehensive assessment and rehabilitation for pelvic floor weakness and abdominal muscle separation after childbirth.",
  icon: Baby
}, {
  title: "Pelvic Organ Prolapse",
  description: "Conservative management strategies including specialised pelvic floor muscle training and practical lifestyle advice.",
  icon: Activity
}, {
  title: "Pelvic Pain",
  description: "Specialised, compassionate care for conditions like endometriosis, and general pelvic floor tension.",
  icon: HeartPulse
}, {
  title: "Bowel Dysfunction",
  description: "Discreet management of constipation, urgency, and incontinence through targeted therapies and exercises.",
  icon: Wind
}, {
  title: "Menopause Support",
  description: "Expert guidance and treatment for pelvic health changes associated with perimenopause and menopause transitions.",
  icon: ThermometerSun
}];
export default function CommonConditionsWeTreat() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const getAnimationClass = (index: number) => {
    if (!isVisible) return "opacity-0 translate-y-4";
    const position = index % 3;
    if (position === 1) return "animate-fade-in-up-delay-100";
    if (position === 2) return "animate-fade-in-up-delay-200";
    return "animate-fade-in-up";
  };
  return <section id="common-conditions-we-treat" className="bg-[var(--color-dark-section)] py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-6">
            Common Conditions We Treat
          </h2>
          <p className="text-lg text-white/70">We provide specialised, evidence-based care for a wide range of pelvic health conditions, helping you return to the activities you love with confidence.</p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {conditions.map((condition, i) => {
          const Icon = condition.icon;
          return <div key={i} data-index={i} className={getAnimationClass(i)}>
                <Card className="h-full bg-white/5 border-white/10 backdrop-blur-md shadow-none hover:bg-white/10 transition-colors duration-300">
                  <CardHeader className="gap-4 pb-4">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-[var(--color-accent)]/10">
                      <Icon className="h-6 w-6 text-[var(--color-accent)]" aria-hidden="true" />
                    </div>
                    <CardTitle className="text-xl font-display text-white">
                      {condition.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-white/70 leading-relaxed">
                      {condition.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}